<template>
  <SectionLayout layout-empty custom-class="no-shadow p-0" disabled-custom>
    <div class="d-flex justify-content-center align-items-center flex-column section__placeholder">
      <img :src="thumbnail" />
      <div class="section__placeholder-desc d-flex flex-column align-items-center">
        <p class="mt-2 text-center paragraph-14-regular text-dark6 section__placeholder-text1">
          {{ textFormat.first }}
        </p>
        <p class="text-center paragraph-14-regular text-dark6 section__placeholder-text2" :class="{'is-right': !isLeft}">
          {{ textFormat.second }}
          <span class="txt-primary-300 clickable" @click="clickAddWidget">{{ $t("dashboard.addWidgets") }}</span>
          {{ $t("dashboard.sectionPlaceholderDesc2") }}
        </p>
      </div>
    </div>
  </SectionLayout>
</template>

<script>
import SectionLayout from "./SectionLayout.vue";

export default {
  name: "SectionPlaceholder",
  components: {
    SectionLayout
  },
  props: {
    side: {
      type: String,
      default: "left"
    }
  },
  computed: {
    isLeft() {
      return this.side == "left";
    },
    textFormat() {
      const rawText = this.$t("dashboard.sectionPlaceholderDesc1").trim().split(".");
      const [first, second] = rawText;
      return {first, second};
    },
    thumbnail() {
      if (this.isLeft) {
        return require("@/core/assets/new-dashboard/empty-section-left.svg");
      } else {
        return require("@/core/assets/new-dashboard/empty-section-right.svg");
      }
    }
  },
  methods: {
    clickAddWidget() {
      this.$emit("add-widget");
    }
  }
};
</script>

<style lang="scss">
.section {
  &__placeholder {
    min-height: 207px;
    padding-left: 44px;
    padding-right: 44px;
    border: 1px solid #eeeeee;
    border-radius: $radius;
    &-text2 {
      &.is-right {
        width: 200px;
      }
    }
  }
}
</style>
